// pour la recherche
export enum FiltersKey {
    SEARCH = "search",
    DATESTART = "ds",
    DATEEND = "de",
    STATE = "states",
}

export enum DateKey {
    DATESTART = FiltersKey.DATESTART,
    DATEEND = FiltersKey.DATEEND,
} 

export enum StationKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum UserKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum NotificationKey {
    SEARCH = FiltersKey.SEARCH,
    DATESTART = FiltersKey.DATESTART,
    DATEEND = FiltersKey.DATEEND,
}
export enum StationAlarmeKey {
    SEARCH = FiltersKey.SEARCH,
    DATESTART = FiltersKey.DATESTART,
    DATEEND = FiltersKey.DATEEND,
}

export enum BadgeSearchListKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum BadgeStockListKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum CustomerAccountListKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum SubscriptionKey {
    SEARCH = FiltersKey.SEARCH,
    DATESTART = FiltersKey.DATESTART,
    DATEEND = FiltersKey.DATEEND,
}
export enum SubscriptionPlanVehicleKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum SubscriptionPlanListTagKey {
    SEARCH = FiltersKey.SEARCH,
}
export enum VehicleKey {
    SEARCH = FiltersKey.SEARCH,
}

export enum AlarmKey {
    SEARCH = FiltersKey.SEARCH,
    DATESTART = FiltersKey.DATESTART,
    DATEEND = FiltersKey.DATEEND,
    STATE = FiltersKey.STATE,
}

export enum TicketKey {
    SEARCH = FiltersKey.SEARCH,
    DATESTART = FiltersKey.DATESTART,
    DATEEND = FiltersKey.DATEEND,
    STATE = FiltersKey.STATE,
}
